module.exports = __webpack_public_path__ + "img/coordinator.8cd48b2a.svg";